

















































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import MonthSelectorVue from "../components/MonthSelector.vue";
@Component({
    components: {
        "month-selector": MonthSelectorVue,
    },
})
export default class Adjusting extends Vue {
    carryList: Adjusting.Adjusting[] = [
        {
            name: "结转销售成本",
            adjustingType: "",
        },
        {
            name: "计提工资",
            adjustingType: "",
        },
        {
            name: "计提折旧",
            adjustingType: "",
        },
        {
            name: "摊销无形资产",
            adjustingType: "",
        },
        {
            name: "摊销待摊费用",
            adjustingType: "",
        },
        {
            name: "计提税金",
            adjustingType: "",
        },
        {
            name: "结转未交增值税",
            adjustingType: "",
        },
        {
            name: "计提印花税",
            adjustingType: "",
        },
        {
            name: "计提所得税",
            adjustingType: ""
        },
        {
            name: "结转汇兑损益",
            adjustingType: "",
        },
        {
            name: "结转损益",
            adjustingType: "",
        },
        {
            name: "结转到未分配利润",
            adjustingType: "",
        },
        {
            name: "结转限定性净资产",
            adjustingType: "",
        },
        {
            name: "结转非限定性净资产",
            adjustingType: "",
        },

    ];
    title: string = "";
    //获取科目列表
    idlkk = 19406
    subjectList: any = []
    getSubjects() {
        Vue.axios
            .post(`subjects/findleaf`, {
                accountBookId: this.$store.state.accountBook.id
            })
            .then(res => {
                res.data.forEach((e:any) => {
                    if(e.id) {
                        e.id = e.id.toString()
                    }
                });
                this.subjectList = res.data
                console.log(this.subjectList)
            });
    }

    mounted() {
        this.getSubjects()
        // this.fetchData()
    }

    monthStr: string[] = [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
    ];

    //改变时间
    period: String[] = []; // 日期
    changeDate(date: string[]) {
        this.period = date;
        this.isInit = 2;
        this.fetchData(2);
    }

    // 获取表格数据
    isInit: number = 2;
    fetchData(isInit?: number) {
        if (isInit) {
            this.isInit = isInit;
        }
        Vue.axios
            .post(`adjusting`, {
                accountBookId: this.$store.state.accountBook.id,
                endPeriod: this.period,
                isInit: this.isInit,
            })
            .then(res => {
                // 获取表格数据，并且合并到本地
                this.$set(
                    this.carryList,
                    0,
                    Object.assign(this.carryList[0], res.data.jzxscb)
                );
                if (res.data.jzxscb) this.carryList[0].adjustingType = "jzxscb";
                else this.carryList[0].adjustingType = null;
                this.$set(
                    this.carryList,
                    1,
                    Object.assign(this.carryList[1], res.data.jtgz)
                );
                if (res.data.jtgz) this.carryList[1].adjustingType = "jtgz";
                else this.carryList[1].adjustingType = null;
                this.$set(
                    this.carryList,
                    2,
                    Object.assign(this.carryList[2], res.data.jtzj)
                );
                if (res.data.jtzj) this.carryList[2].adjustingType = "jtzj";
                else this.carryList[2].adjustingType = null;


                this.$set(
                    this.carryList,
                    3,
                    Object.assign(this.carryList[3], res.data.txwxzc)
                );

                if (res.data.txwxzc) this.carryList[3].adjustingType = "txwxzc";
                else this.carryList[3].adjustingType = null;


                this.$set(
                    this.carryList,
                    4,
                    Object.assign(this.carryList[4], res.data.txdtfy)
                );

                if (res.data.txdtfy) this.carryList[4].adjustingType = "txdtfy";
                else this.carryList[4].adjustingType = null;

                this.$set(
                    this.carryList,
                    5,
                    Object.assign(this.carryList[5], res.data.jtsj)
                );
                // res.data.jtsj.texts.forEach((e:any) => {
                //     if(e.per) {
                //         e.per = Number(e.per)
                //     }
                // });
                if (res.data.jtsj) this.carryList[5].adjustingType = "jtsj";
                else this.carryList[5].adjustingType = null;

                this.$set(
                    this.carryList,
                    6,
                    Object.assign(this.carryList[6], res.data.jzwjzzs)
                );

                if (res.data.jzwjzzs)
                    this.carryList[6].adjustingType = "jzwjzzs";
                else this.carryList[6].adjustingType = null;

                this.$set(
                    this.carryList,
                    8,
                    Object.assign(this.carryList[8], res.data.jtsds)
                );

                if (res.data.jtsds) this.carryList[8].adjustingType = "jtsds";
                else this.carryList[8].adjustingType = null;

                // res.data.jtyhs.texts.forEach((e:any) => {
                //     if(e.per) {
                //         e.per = Number(e.per)
                //     }
                // });
                this.$set(
                    this.carryList,
                    7,
                    Object.assign(this.carryList[7], res.data.jtyhs)
                );

                if (res.data.jtyhs)
                    this.carryList[7].adjustingType = "jtyhs";
                else this.carryList[7].adjustingType = null;

                this.$set(
                    this.carryList,
                    9,
                    Object.assign(this.carryList[9], res.data.jzhdsy)
                );

                if (res.data.jzhdsy) this.carryList[9].adjustingType = "jzhdsy";
                else this.carryList[9].adjustingType = null;

                this.$set(
                    this.carryList,
                    10,
                    Object.assign(this.carryList[10], res.data.jzsy)
                );

                if (res.data.jzsy) this.carryList[10].adjustingType = "jzsy";
                else this.carryList[10].adjustingType = null;

                this.$set(
                    this.carryList,
                    11,
                    Object.assign(this.carryList[11], res.data.jzdwfplr)
                );

                if (res.data.jzdwfplr != null)
                    this.carryList[11].adjustingType = "jzdwfplr";
                else this.carryList[11].adjustingType = null;

                this.$set(
                    this.carryList,
                    12,
                    Object.assign(this.carryList[12], res.data.jzxdxjzc)
                );

                if (res.data.jzxdxjzc) this.carryList[12].adjustingType = "jzxdxjzc";
                else this.carryList[12].adjustingType = null;

                this.$set(
                    this.carryList,
                    13,
                    Object.assign(this.carryList[13], res.data.jzfxdxjzc)
                );

                if (res.data.jzfxdxjzc)
                    this.carryList[13].adjustingType = "jzfxdxjzc";
                else this.carryList[13].adjustingType = null;

                this.title = res.data.text;
                this.$forceUpdate();
            });
    }

    // 测算金额
    clickAmount() {
        this.isInit = 1;
        this.fetchData(1);
    }

    // 修改气泡窗内的texts.per
    perClick(text: Adjusting.Text) {
        let keyword = "";
        console.log(text)
        if (text.text) {
            if (text.text === "2.结转百分比：") {
                keyword = "CARRY_PERCENTAGE";
            } else if (text.text.includes("所得税税率")) {
                keyword = "INCOME_TAX_RATE";
            } else if (text.text === "2.应交城市维护建设税税率：") {
                keyword = "CITY_FEE_RATE";
            } else if (text.text === "3.教育费附加税率：") {
                keyword = "EDUCATION_FEE_RATE";
            } else if (text.text === "4.地方教育费附加税率：") {
                keyword = "LOCAL_EDUCATION_FEE_RATE";
            } else if (text.text === "3.印花税税率：") {
                keyword = "STAMP_TAX_PERCENTAGE";
            } else if (text.text === "1.以前年度亏损：") {
                keyword = "PREVIOUS_LOSS";
            } else {
                keyword = text.text.replace(/汇率：/g, "");
            }
        }
        Vue.axios
            .post(`systemsettings/save`, {
                accountBookId: this.$store.state.accountBook.id,
                keyword: keyword,
                value: text.per,
            })
            .then(() => {
                this.clickAmount();
            });
    }

    //生成凭证
    createPZ(voucher: Voucher.Voucher) {
        this.voucherVisible = true;
        this.$nextTick(function () {
            let newVoucher: any = this.$refs.newVoucher,
                period: any = new Date(voucher.voucherDate),
                now: any =
                    period.getFullYear() + this.monthStr[period.getMonth()];
            this.fetchVoucher(now);
            newVoucher.isInsert = 0;
            newVoucher.isEdit = false;
            newVoucher.isDialog = true;
            newVoucher.showSaveAndAdd = false;
            newVoucher.showAdd = false;
            newVoucher.isCheck = true;
            newVoucher.shouldGetInit = false;
            newVoucher.getSubjectList(null, () => {
                newVoucher.packVoucher(voucher);
            });
        });
    }
    //查看凭证
    voucherVisible: boolean = false;
    viewVoucher(id: number | null) {
        Vue.axios.post(`voucher/` + id + `/find`, {}).then((res) => {
            this.voucherVisible = true;
            this.$nextTick(() => {
                let newVoucher: any = this.$refs.newVoucher,
                    period: Date = new Date(res.data.voucherDate),
                    now: any =
                        period.getFullYear() + this.monthStr[period.getMonth()];
                this.fetchVoucher(now);
                newVoucher.isDialog = true;
                newVoucher.isInsert = 0;
                newVoucher.showSaveAndAdd = false;
                newVoucher.showAdd = false;
                newVoucher.isCheck = true;
                newVoucher.shouldGetInit = false;
                newVoucher.getSubjectList(null, () => {
                    newVoucher.packVoucher(res.data);
                });
            });
        });
    }
    fetchVoucher(date: any) {
        this.$nextTick(function () {
            let newVoucher: any = this.$refs.newVoucher;
            if (
                Number(this.period) <=
                Number(this.$store.state.accountBook.closePeriod)
            ) {
                newVoucher.isClose = true;
            } else {
                newVoucher.isClose = false;
            }
        });
    }
    //关闭凭证MODAL
    closeVoucher() {
        let newVoucher: any = this.$refs.newVoucher;
        this.voucherVisible = false;
        this.fetchData(this.isInit);
        newVoucher.resetVoucher();
    }
    // 更新
    update(item: any) {
        Vue.axios
            .post(
                `adjusting/update?voucherId=${item.voucherId}&adjustingType=${item.adjustingType}&period=${this.period}&accountBookId=${this.$store.state.accountBook.id}`,
                { nothing: "" }
            )
            .then(() => {
                this.fetchData(1);
            });
    }

    // 批量生成凭证
    multiVoucherVisible = false;
    multiList: string[] = [];
    isIndeterminate = false;
    checkAll = false;

    allTypes: { label: string; key: string; }[] = [];
    @Watch("carryList", { deep: true })
    carryListChanged(val: Adjusting.Adjusting[]) {
        const list: { label: string; key: string; }[] = [];
        val.forEach(carry => {
            if (carry.adjustingType && carry.button === 2) list.push({ label: carry.name, key: carry.adjustingType });
        });
        this.allTypes = list;
    }

    handleCheckAllChange(val: boolean) {
        const all: string[] = [];
        this.allTypes.forEach(type => {
            all.push(type.key);
        });
        this.multiList = val ? all : [];
        this.isIndeterminate = false;
    }
    handleCheckedMultiChange(value: string[]) {
        const checkedCount = value.length;
        this.checkAll = checkedCount === this.allTypes.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.allTypes.length;
    }

    async multiVoucherConfirm() {
        for (let i = 0; i < this.multiList.length; i++) {
            const type = this.multiList[i];
            await Vue.axios.post(`adjusting/update?adjustingType=${type}&period=${this.period}&accountBookId=${this.$store.state.accountBook.id}`, { nothing: "" });
        }
        this.multiVoucherVisible = false;
        this.multiList = [];
        this.checkAll = false;
        await this.fetchData(this.isInit);
    }
}
